import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const Notification = ({
  successMessage,
  setSuccessMessage,
  message,
  setMessage,
  editMessage,
  setEditMessage,
  editPopup,
  setEditPopup,
  editToastMsg,
  setEditToastMsg,
}) => {
  const navigate = useNavigate();
  const [storedDirectorId, setStoredDirectorId] = useState(null);

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [successMessage, setSuccessMessage]);

  useEffect(() => {
    if (editMessage) {
      const timer = setTimeout(() => {
        setEditMessage("");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [editMessage, setEditMessage]);

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [message, setMessage]);

  useEffect(() => {
    if (editPopup) {
      const timer = setTimeout(() => {
        setEditPopup("");
      }, 5000);
      navigate("", { replace: true });
      return () => clearTimeout(timer);
    }
  }, [editPopup, setEditPopup]);

  useEffect(() => {
    if (editToastMsg) {
      const timer = setTimeout(() => {
        setEditToastMsg("");
      }, 5000);
      navigate("", { replace: true });
      return () => clearTimeout(timer);
    }
  }, [editToastMsg, setEditToastMsg]);

  useEffect(() => {
    const id = localStorage.getItem("directorId");
    if (id) {
      setStoredDirectorId(id);
    }
  }, []);

  if (
    !successMessage &&
    !message &&
    !editMessage &&
    !editPopup &&
    !editToastMsg
  )
    return null;

  const handleLinkClick = () => {
    localStorage.removeItem("directorId");
  };

  return (
    <div className="col-12">
      {successMessage && (
        <div className="success-message w-full">
          <span className="pi pi-check mr-2 check-color"></span>
          <p>{successMessage}</p>
        </div>
      )}
      {message && (
        <div className="deletion-msg w-full">
          <span className="pi pi-times-circle mr-2 cancel-color"></span>
          <p>{message}</p>
        </div>
      )}
      {editMessage && (
        <div className="success-edit-message w-full">
          <span className="pi pi-check mr-2 check-color"></span>
          <p>{editMessage}</p>
        </div>
      )}
      {editPopup && (
        <div className="success-edit-message w-full">
          <span className="pi pi-check mr-2 check-color"></span>
          <p>
            {editPopup}
            <Link
              className="link-item"
              to={`/directors/${storedDirectorId}`}
              onClick={handleLinkClick}
            >
              View Profile
            </Link>
          </p>
        </div>
      )}
      {editToastMsg && (
        <div className="edit-toast-message w-full">
          <span className="pi pi-check mr-2 check-color"></span>
          <p>{editToastMsg}</p>
        </div>
      )}
    </div>
  );
};

export default Notification;
